import { render } from "./FireIcon.svg?vue&type=template&id=2fe03a94"
const script = {}
script.render = render

export default script